import { CargoConverterService } from './CargoConverterService';
import { CargoConverterServiceInterface } from './interfaces';

// Фабрика сервиса
export const cargoConverterService: {
  (token?: string): CargoConverterServiceInterface;
} = (token) => new CargoConverterService(token);
